export default "__VITE_ASSET__DBd8xwMK__"